<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <input
          ref="input-select-medicine"
          type="text"
          class="form-control"
          placeholder="PESQUISAR POR NOME COMERCIAL/PRINCÍPIO ATIVO/CLASSE TERAPÊUTICA"
          @input="handleComponentFilterMedicines"
          v-model="searchComponentFilterMedicines"
        />
      </div>
      <div class="col-md-12">
        <b-overlay :show="loadingComponentFilterMedicines" opacity="0.99">
          <v-list-item
            @click="handleClickCreateMedicine"
            v-if="
              newMedicine &&
              searchComponentFilterMedicines &&
              permission('write', 'medicine')
            "
            three-line
          >
            <v-list-item-content>
              <v-list-item-title>
                <strong class="upper-text">
                  {{ searchComponentFilterMedicines }}</strong
                ></v-list-item-title
              >
              <v-list-item-subtitle class="text-fourteen weight-600">
                MEDICAMENTO - PERSONALIZADO
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-fourteen weight-600">
                NOVO MEDICAMENTO CADASTRAR
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-data-table
            dense
            :headers="[{ sortable: false, value: 'item' }]"
            item-key="`${type}`/${id}"
            :items="componentFilterMedicines"
            :footer-props="{
              'items-per-page-options': [35],
              'items-per-page-text': 'Mostrar',
            }"
            no-data-text="SEM RESULTADOS"
            :options.sync="optionsComponentFilterMedicines"
            :server-items-length="totalComponentFilterMedicines"
            @click:row="handleClickRowTableComponentFilterMedicines"
            class="SelectMedicineID-table"
          >
            <template v-slot:[`item.item`]="{ item }">
              <div class="pt-1 pb-1">
                <h6 class="mb-0">
                  NOME COMERCIAL:
                  {{ item.name }}
                </h6>
                <div class="mb-0">
                  PRINCÍPIO ATIVO:
                  {{ item.active_ingredient }}
                </div>
                <div class="mb-0">
                  TIPO DE RECEITA:
                  {{ item.type_of_recipe_name }}
                </div>

                <div class="mb-0" v-if="item.list">
                  LISTA:
                  {{ item.list }}
                </div>
                <div class="mb-0">
                  CLASSE TERAPÊUTICA:
                  {{ item.therapeutic_class }}
                </div>
                <div class="mb-0">
                  UNIDADE DE MEDIDA:
                  {{ item.unit_of_measurement_name }}
                </div>
                <div class="mb-0">
                  TIPO:
                  {{ item.type == "PADRAO" ? "PADRÃO" : "EMPRESA" }}
                </div>
              </div>
            </template>
          </v-data-table>
        </b-overlay>
      </div>
      <div
        v-if="medicineComponentFilterMedicines.id && showMedicine"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
      >
        <strong>
          <span class="text-muted">NOME COMERCIAL:</span>
          {{ medicineComponentFilterMedicines.name }}
        </strong>
        <br />
        <small>
          <strong>
            <span class="text-muted">PRINCÍPIO ATIVO:</span>
            {{ medicineComponentFilterMedicines.active_ingredient }}
          </strong>
        </small>
        <br />
        <small>
          <strong>
            <span class="text-muted">TIPO DE RECEITA:</span>
            {{ medicineComponentFilterMedicines.type_of_recipe_name }}
          </strong>
        </small>
        <br />
        <small>
          <strong>
            <span class="text-muted">LISTA:</span>
            {{ medicineComponentFilterMedicines.list }}
          </strong>
        </small>
        <br />
        <small>
          <strong>
            <span class="text-muted">CLASSE TERAPÊUTICA:</span>
            {{ medicineComponentFilterMedicines.therapeutic_class }}
          </strong>
        </small>
        <br />
        <small>
          <strong>
            <span class="text-muted">UNIDADE DE MEDIDA:</span>
            {{ medicineComponentFilterMedicines.unit_of_measurement_name }}
          </strong>
        </small>
        <br />
        <small>
          <strong>
            <span class="text-muted">TIPO:</span>
            {{
              medicineComponentFilterMedicines.type == "PADRAO"
                ? "PADRÃO"
                : "EMPRESA"
            }}
          </strong>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import permission from "../../lib/permission";

export default {
  name: "SelectMedicineID",
  props: {
    showMedicine: Boolean,
    newMedicine: { type: Boolean, default: true },
  },
  data() {
    return {
      totalComponentFilterMedicines: 0,
      optionsComponentFilterMedicines: {
        page: 1,
        itemsPerPage: 35,
      },
      medicineComponentFilterMedicines: {},
      componentFilterMedicines: [],
      searchComponentFilterMedicines: "",
      loadingComponentFilterMedicines: false,
    };
  },
  watch: {
    optionsComponentFilterMedicines: {
      handler() {
        this.handleComponentFilterMedicines();
      },
    },
  },
  created() {
    setTimeout(() => this.$refs["input-select-medicine"].focus(), 200);
  },
  methods: {
    permission,
    handleClickRowTableComponentFilterMedicines(medicine) {
      this.medicineComponentFilterMedicines = medicine;
      this.$emit("selected", medicine);
    },
    handleClickCreateMedicine() {
      const { searchComponentFilterMedicines: medicine } = this;
      this.medicineComponentFilterMedicines = medicine;
      this.$emit("selected", medicine);
    },
    async handleComponentFilterMedicines() {
      try {
        this.loadingComponentFilterMedicines = true;

        const { page, itemsPerPage } = this.optionsComponentFilterMedicines;

        const { searchComponentFilterMedicines } = this;

        let params = {
          filter: searchComponentFilterMedicines,
          page,
          itemsPerPage,
        };

        const response = await api.get("/rest-home/medicine/filter", {
          params,
        });

        const { error, errors, medicines, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.componentFilterMedicines = medicines;
          this.totalComponentFilterMedicines = total;

          this.loadingComponentFilterMedicines = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.SelectMedicineID-table {
  max-height: 300px !important;
  overflow: scroll;
}
</style>